export default "__VITE_ASSET__D0PPB6GZ__"